var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"important-notice"},[_vm._v(" ⚠️ "),_c('span',{staticClass:"notice-title"},[_vm._v("Important notice:")]),_c('br'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }